import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { Breadcrumbs } from '@/components/atomic/Breadcrumbs'
import { PageContainer } from '@/components/atomic/PageContainer'
import { PageMetaData } from '@/components/atomic/PageMetaData'
import { ChatWidget } from '@/components/styleguide/ChatWidget'
import { Header } from '@/components/styleguide/Header'
import { ROUTES } from '@/lib/routes'
import { getFaqArticleContentService } from '@/lib/services/pageService'

const Container = dynamic(() => import('@/components/views/FaqPage/Container'))

const FaqsArticlePage = ({ article }) => {
  const router = useRouter()

  const [breadcrumbs] = useState([
    {
      title: 'Home',
      slug: ROUTES.homePage.url,
    },
    {
      title: `FAQs`,
      slug: ROUTES.faqsPage.url,
    },
    {
      title: `${article.title}`,
      slug: null,
    },
  ])

  useEffect(() => {
    if (typeof window.ttq !== 'undefined') {
      window.ttq.track('ViewContent', {
        /* eslint-disable */
        content_id: `${article.title}`,
        content_type: 'product',
        content_name: `${article.title}`,
        /* eslint-enable */
        quantity: 1,
        value: null,
        price: null,
        currency: 'GBP',
      })
    }
  }, [article.title])

  if (!article) {
    return <div>loading...</div>
  }

  return (
    <>
      <PageMetaData
        title={`${article.title} | FAQ | LeaseLoco`}
        description={article.metaDescription}
        pageUrl={router.asPath}
      />
      <ChatWidget />
      <Header backgroundColor="white" />
      <PageContainer containerClass="container--faq-article">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1>{article.title}</h1>
        <Container article={article} />
      </PageContainer>
    </>
  )
}

export default FaqsArticlePage

export const getServerSideProps = async context => {
  try {
    const request = await getFaqArticleContentService()
    const article = await request.filter(article => article.slug === context.params.slug)[0]

    return {
      props: {
        article,
      },
    }
  } catch (err) {
    return {
      notFound: true,
    }
  }
}
